export default "__VITE_ASSET__hlxRBTb7__"